import type { OptionDB } from "@project/emerge";
import { Sides } from "@project/emerge-types";
import { Covers } from "../enum/Covers";
import { LTProducts } from "../enum/LTProducts";
import type { FlightCaseSettings } from "../interfaces/FlightCaseSettings";
import { createCoverOptions } from "../structure/RackInterior";
import { FlightCaseDefinition } from "./FlightCaseDefinition";

export class KeyboardCase extends FlightCaseDefinition {
  public static extraInfoTexts = {
    OptionAccessoriesCompartment: "mit Zubehörfach",
    OptionAdditionalBackRackRail: "mit Backrackrail",
    OptionLeatherHandle: "mit Ledergriff",
    OptionPlayableInCase: "im Case spielbar",
    OptionRemovableCap: "abnehmbarer Deckel",
    OptionStackable: "stapelbar",
    OptionTrolleyFunction: "Trolleyfunktion",
  };

  public static getSerializedDefaultVersion(
    optionDb: OptionDB,
  ): FlightCaseSettings {
    const result: FlightCaseSettings =
      FlightCaseDefinition.getSerializedDefaultVersion(optionDb);
    result.type = LTProducts.KeyboardCase;
    result.exteriorOptions.strength = 6.5;
    result.variableOptions = [];
    result.cuts = [
      {
        groupName: Covers.BASE,
        invertCover: true,
        offset: 50,
        reference: Sides.BOTTOM,
      },
    ];
    result.coverPaddings = createCoverOptions(optionDb, result.cuts);
    return result;
  }

  public isHood = true;
}
